import { Mail, Phone, MapPin, Linkedin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { href: "#o-problema", label: "O Problema" },
    { href: "#nossa-solucao", label: "Nossa Solução" },
    { href: "#como-funciona", label: "Como Funciona" },
    { href: "#servicos", label: "Serviços" },
    { href: "#clientes", label: "Clientes" },
    { href: "#equipe", label: "Equipe" },
    { href: "#faq", label: "FAQ" },
  ];

  return (
    <footer
      style={{
        background: "var(--color-preto-marca)",
        borderTop: "1px solid var(--color-dourado)",
      }}
    >
      <div className="container mx-auto px-4 lg:px-6">
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <a href="#inicio" className="mb-4 cursor-pointer w-fit block">
                <img src="/logo-branco.svg" alt="SIATECH" className="h-8 w-auto" />
              </a>
              <p
                className="text-sm font-light leading-relaxed max-w-md"
                style={{ color: "var(--color-cinza-ancora)" }}
              >
                Expertise e tecnologia proprietária para o processo de AFRMM.
                Transformamos burocracia em eficiência.
              </p>
            </div>

            <div className="space-y-3 mb-6">
              <a
                href="tel:+5591981573458"
                className="flex items-center gap-3 cursor-pointer w-fit transition-colors duration-200"
                style={{ color: "var(--color-cinza-ancora)" }}
                onMouseEnter={(e) =>
                  ((e.currentTarget as HTMLElement).style.color = "var(--color-dourado)")
                }
                onMouseLeave={(e) =>
                  ((e.currentTarget as HTMLElement).style.color = "var(--color-cinza-ancora)")
                }
              >
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span className="text-sm font-light">+55 (91) 98157-3458</span>
              </a>
              <a
                href="mailto:contato@siatechbrasil.com.br"
                className="flex items-center gap-3 cursor-pointer w-fit transition-colors duration-200"
                style={{ color: "var(--color-cinza-ancora)" }}
                onMouseEnter={(e) =>
                  ((e.currentTarget as HTMLElement).style.color = "var(--color-dourado)")
                }
                onMouseLeave={(e) =>
                  ((e.currentTarget as HTMLElement).style.color = "var(--color-cinza-ancora)")
                }
              >
                <Mail className="w-4 h-4 flex-shrink-0" />
                <span className="text-sm font-light">contato@siatechbrasil.com.br</span>
              </a>
              <div
                className="flex items-center gap-3"
                style={{ color: "var(--color-cinza-ancora)" }}
              >
                <MapPin className="w-4 h-4 flex-shrink-0" />
                <span className="text-sm font-light">Belém - PA</span>
              </div>
            </div>

            {/* Social */}
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/company/siatech-afrmm/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded cursor-pointer transition-all duration-200"
                style={{
                  border: "1px solid rgba(176, 175, 172, 0.2)",
                  color: "var(--color-cinza-ancora)",
                }}
                aria-label="LinkedIn da SIATECH"
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLElement).style.borderColor = "var(--color-dourado)";
                  (e.currentTarget as HTMLElement).style.color = "var(--color-dourado)";
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLElement).style.borderColor =
                    "rgba(176, 175, 172, 0.2)";
                  (e.currentTarget as HTMLElement).style.color = "var(--color-cinza-ancora)";
                }}
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4
              className="text-xs font-semibold uppercase tracking-wider mb-4"
              style={{ color: "var(--color-branco-vela)" }}
            >
              Navegação
            </h4>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm font-light cursor-pointer transition-colors duration-200"
                    style={{ color: "var(--color-cinza-ancora)" }}
                    onMouseEnter={(e) =>
                      ((e.target as HTMLElement).style.color = "var(--color-dourado)")
                    }
                    onMouseLeave={(e) =>
                      ((e.target as HTMLElement).style.color = "var(--color-cinza-ancora)")
                    }
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4
              className="text-xs font-semibold uppercase tracking-wider mb-4"
              style={{ color: "var(--color-branco-vela)" }}
            >
              Começar
            </h4>
            <p
              className="text-sm font-light mb-4"
              style={{ color: "var(--color-cinza-ancora)" }}
            >
              Descubra se sua empresa tem direito ao AFRMM.
            </p>
            <a href="#contato" className="btn-outline-dark inline-flex">
              Análise Gratuita
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div
          className="py-6"
          style={{ borderTop: "1px solid rgba(176, 175, 172, 0.1)" }}
        >
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div
              className="text-xs font-light"
              style={{ color: "var(--color-cinza-ancora)" }}
            >
              &copy; {currentYear} Siatech Brasil. Todos os direitos reservados.
            </div>
            <div className="flex gap-6">
              {["Política de Privacidade", "Termos de Uso"].map((label) => (
                <a
                  key={label}
                  href="#"
                  className="text-xs font-light cursor-pointer transition-colors duration-200"
                  style={{ color: "var(--color-cinza-ancora)" }}
                  onMouseEnter={(e) =>
                    ((e.target as HTMLElement).style.color = "var(--color-dourado)")
                  }
                  onMouseLeave={(e) =>
                    ((e.target as HTMLElement).style.color = "var(--color-cinza-ancora)")
                  }
                >
                  {label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
